import { render, staticRenderFns } from "./PreAssociation.vue?vue&type=template&id=2365cab5"
import script from "./PreAssociation.vue?vue&type=script&lang=js"
export * from "./PreAssociation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports